import { useEffect, useState } from "react";
import "../css/technique.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import SubTechniqueSection from "../components/SubTechniqueSection.js";


function TechniquePage(){

    
    const { techniqueName } = useParams();
    const [data,setData] = useState(null);
    const [subTechniques,setSubTechniques] = useState([]);
    
    useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [techniqueName]);

    useEffect(()=>{
        let mounted = true;

        axios.get(`https://jiujitsu-json-data.s3.ap-northeast-2.amazonaws.com/jiujitsu/jiujitsu_techniques.json?v=${Date.now()}`)
        .then((resp)=>{
            if (!mounted) return; 

            setData(resp.data.find((item) => item.techniqueName.toLowerCase() === techniqueName.toLocaleLowerCase()));

            setSubTechniques(resp.data.find((item) => item.techniqueName.toLowerCase() === techniqueName.toLocaleLowerCase()).subTechniques)


        })
    },[techniqueName]);
    
    return (
        <>
            <main className="main-technique">
                <div className="title-container">
                    <p>{data?.techniqueName?.replace(/([a-z])([A-Z])/g, '$1 $2')}</p>
                    <p>{data?.techniqueDescription}</p>
                </div>
                <SubTechniqueSection subTechniques={subTechniques} />
            </main>
        </>


    )

}


export default TechniquePage;